<script lang="ts">
	import { isRightClick, stopEvent } from '$lib/utils/event';

	interface Props {
		beforeText?: string;
		afterText?: string;
		highlightText?: string;
		additionalLabel?: string;
		onSelectItem?: () => void;
	}

	const {
		beforeText,
		afterText,
		highlightText,
		additionalLabel,
		onSelectItem,
	}: Props = $props();

	function handleSelectItem(e: MouseEvent) {
		stopEvent(e);

		if (isRightClick(e)) {
			return;
		}

		onSelectItem?.();
	}

	function handleKeyDown(e: KeyboardEvent) {
		if (e.key === 'Enter') {
			onSelectItem?.();
		}
	}
</script>

<button
	role="listitem"
	onclick={handleSelectItem}
	onkeydown={handleKeyDown}
	class="w-full text-md inline-block py-2 overflow-hidden text-ellipsis cursor-pointer truncate border-0 bg-transparent text-left"
>
	{beforeText}{#if highlightText}<mark class="font-bold bg-transparent">{highlightText}</mark>{/if}{afterText}{#if additionalLabel}<small class="text-3.5 px-1.5">{additionalLabel}</small>{/if}
</button>
